import { createI18n } from "vue-i18n";
import moment from "moment";
import "moment/locale/id";
import id from "./locales/id";
import en from "./locales/en";

const STORAGE_KEY = "ligno_lang";

// bahasa yang dipilih user lewat toggle (null kalau belum pernah memilih)
function getSavedLocale() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "id" || stored === "en") return stored;
  } catch (e) {
    // localStorage tidak tersedia (mis. private mode); pakai default
  }
  return null;
}

// tebakan awal dari bahasa browser, supaya render pertama sudah masuk akal
// sebelum hasil deteksi lokasi (async) datang
function detectBrowserLocale() {
  const langs = navigator.languages || [navigator.language];
  const isIndo = langs.some(
    (l) => typeof l === "string" && l.toLowerCase().startsWith("id"),
  );
  return isIndo ? "id" : "en";
}

// deteksi negara dari IP pengunjung (geojs.io: gratis, HTTPS, CORS).
// Mengembalikan kode negara ("ID", "US", ...) atau null kalau gagal/timeout.
async function detectCountry() {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000);
    const resp = await fetch("https://get.geojs.io/v1/ip/country.json", {
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    const data = await resp.json();
    return data && data.country ? data.country : null;
  } catch (e) {
    return null;
  }
}

const savedLocale = getSavedLocale();
const initialLocale = savedLocale || detectBrowserLocale();

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: initialLocale,
  fallbackLocale: "id",
  messages: { id, en },
});

// terapkan bahasa ke i18n + moment + <html lang>, TANPA menyimpan pilihan
function applyLocale(locale) {
  i18n.global.locale.value = locale;
  moment.locale(locale);
  document.documentElement.setAttribute("lang", locale);
}

// import "moment/locale/id" di atas menggeser locale global moment ke "id",
// jadi selaraskan lagi dengan bahasa awal
applyLocale(initialLocale);

// dipanggil dari toggle bahasa: terapkan DAN simpan sebagai pilihan user
export function setLocale(locale) {
  applyLocale(locale);
  try {
    localStorage.setItem(STORAGE_KEY, locale);
  } catch (e) {
    // abaikan; bahasa tetap berlaku untuk sesi ini
  }
}

// Kalau user belum pernah memilih bahasa, sempurnakan default lewat lokasi:
// pengunjung Indonesia -> ID, selain itu -> EN. Berjalan di background agar
// tidak menunda render; pilihan manual selalu menang.
if (!savedLocale) {
  detectCountry().then((country) => {
    if (!country) return; // deteksi gagal: bertahan dgn tebakan bahasa browser
    if (getSavedLocale()) return; // user keburu memilih manual
    const geoLocale = country === "ID" ? "id" : "en";
    if (i18n.global.locale.value !== geoLocale) {
      applyLocale(geoLocale);
    }
  });
}

export default i18n;
